import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Link } from 'react-router-dom';
export function TermsOfServicePage() {
  return <div className="min-h-screen w-full bg-white selection:bg-slate-600 selection:text-white pt-20" data-id="element-430">
      <Header data-id="element-431" />

      <section className="py-24 px-6 lg:px-8 bg-gray-50" data-id="element-432">
        <div className="max-w-4xl mx-auto" data-id="element-433">
          <div className="mb-6 inline-block bg-slate-600 px-4 py-1 transform -skew-x-12" data-id="element-434">
            <span className="block transform skew-x-12 font-bold tracking-wider uppercase text-sm text-white" data-id="element-435">
              Legal
            </span>
          </div>
          <h1 className="text-4xl md:text-6xl font-black tracking-tighter text-black mb-4" data-id="element-436">
            TERMS OF <span className="text-slate-600" data-id="element-437">SERVICE</span>
          </h1>
          <p className="text-gray-600 font-medium" data-id="element-438">
            Last updated: January 2025
          </p>
          <p className="text-gray-700 mt-4 font-bold" data-id="element-439">Raven Advisors LLC</p>
        </div>
      </section>

      <section className="py-16 px-6 lg:px-8 bg-white" data-id="element-440">
        <div className="max-w-4xl mx-auto prose prose-lg prose-gray" data-id="element-441">
          <div className="space-y-12" data-id="element-442">
            <div data-id="element-443">
              <h2 className="text-2xl font-black text-black uppercase tracking-tight mb-4" data-id="element-444">
                1. Acceptance of Terms
              </h2>
              <div className="w-12 h-1 bg-slate-600 mb-6" data-id="element-445"></div>
              <p className="text-gray-700 leading-relaxed" data-id="element-446">
                By accessing or using the Raven Advisors LLC website and
                services, you agree to be bound by these Terms of Service. If
                you do not agree to these terms, please do not use our services.
                You must be at least 18 years of age to use our services.
              </p>
            </div>

            <div data-id="element-447">
              <h2 className="text-2xl font-black text-black uppercase tracking-tight mb-4" data-id="element-448">
                2. Age Restriction
              </h2>
              <div className="w-12 h-1 bg-slate-600 mb-6" data-id="element-449"></div>
              <p className="text-gray-700 leading-relaxed" data-id="element-450">
                <strong data-id="element-451">
                  You must be 18 years of age or older to use our services.
                </strong>{' '}
                By using our website, submitting a contact form, or opting in to
                receive communications, you represent and warrant that you are
                at least 18 years old. If you are under 18, you may not use our
                services.
              </p>
            </div>

            <div data-id="element-452">
              <h2 className="text-2xl font-black text-black uppercase tracking-tight mb-4" data-id="element-453">
                3. Our Services
              </h2>
              <div className="w-12 h-1 bg-slate-600 mb-6" data-id="element-454"></div>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-455">
                Raven Advisors LLC is a real estate purchasing company that
                provides cash offers for residential properties. Our services
                include:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2" data-id="element-456">
                <li data-id="element-457">Property evaluations and assessments</li>
                <li data-id="element-458">Cash offers for residential real estate</li>
                <li data-id="element-459">Facilitation of property purchases</li>
                <li data-id="element-460">Coordination with title companies and closing agents</li>
              </ul>
            </div>

            <div data-id="element-461">
              <h2 className="text-2xl font-black text-black uppercase tracking-tight mb-4" data-id="element-462">
                4. SMS/Text Message Terms
              </h2>
              <div className="w-12 h-1 bg-slate-600 mb-6" data-id="element-463"></div>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-464">
                <strong data-id="element-465">SMS Use Cases:</strong> If you opt-in to receive
                SMS/text messages from Raven Advisors LLC, you may receive:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2" data-id="element-466">
                <li data-id="element-467">Responses to your property inquiries</li>
                <li data-id="element-468">Appointment confirmations and reminders</li>
                <li data-id="element-469">Updates on your cash offer status</li>
                <li data-id="element-470">Closing process notifications</li>
                <li data-id="element-471">Important transactional information</li>
              </ul>

              <p className="text-gray-700 leading-relaxed mt-6 mb-4" data-id="element-472">
                <strong data-id="element-473">Message & Data Rates:</strong> Standard message and data
                rates may apply to any SMS/text messages sent or received. These
                rates are determined by your mobile carrier and are your
                responsibility. Check with your carrier for details about your
                messaging plan.
              </p>

              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-474">
                <strong data-id="element-475">Opt-Out Instructions:</strong> You can opt out of
                receiving SMS/text messages at any time by:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2" data-id="element-476">
                <li data-id="element-477">
                  Replying <strong data-id="element-478">STOP</strong> to any text message you receive
                  from us
                </li>
                <li data-id="element-479">Contacting us at 630-686-7233</li>
                <li data-id="element-480">Emailing us at ravenadvisorsllc@gmail.com</li>
              </ul>
              <p className="text-gray-700 leading-relaxed mt-4" data-id="element-481">
                After opting out, you will receive a confirmation message and no
                further SMS messages will be sent unless you opt back in.
              </p>

              <p className="text-gray-700 leading-relaxed mt-6" data-id="element-482">
                <strong data-id="element-483">Help:</strong> For assistance with SMS messages, reply{' '}
                <strong data-id="element-484">HELP</strong> to any message or contact our customer
                support at 630-686-7233 or ravenadvisorsllc@gmail.com.
              </p>
            </div>

            <div data-id="element-485">
              <h2 className="text-2xl font-black text-black uppercase tracking-tight mb-4" data-id="element-486">
                5. Carrier Liability Disclaimer
              </h2>
              <div className="w-12 h-1 bg-slate-600 mb-6" data-id="element-487"></div>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-488">
                <strong data-id="element-489">Carriers are not liable</strong> for delayed or
                undelivered messages. Message delivery is subject to effective
                transmission from your mobile carrier and is outside of our
                control. The following conditions may impact message delivery:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2" data-id="element-490">
                <li data-id="element-491">Network congestion or outages</li>
                <li data-id="element-492">Coverage limitations in your area</li>
                <li data-id="element-493">Device compatibility issues</li>
                <li data-id="element-494">Carrier filtering or blocking</li>
              </ul>
              <p className="text-gray-700 leading-relaxed mt-4" data-id="element-495">
                T-Mobile, AT&T, Verizon, and other mobile carriers are not
                responsible for any SMS messages that are delayed, not
                delivered, or incorrectly delivered.
              </p>
            </div>

            <div data-id="element-496">
              <h2 className="text-2xl font-black text-black uppercase tracking-tight mb-4" data-id="element-497">
                6. Customer Support
              </h2>
              <div className="w-12 h-1 bg-slate-600 mb-6" data-id="element-498"></div>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-499">
                For any questions, concerns, or assistance with our services,
                please contact our customer support team:
              </p>
              <div className="p-6 bg-gray-50 border-l-4 border-slate-600" data-id="element-500">
                <p className="font-bold text-black" data-id="element-501">Raven Advisors LLC</p>
                <p className="text-gray-700" data-id="element-502">Phone: 630-686-7233</p>
                <p className="text-gray-700" data-id="element-503">
                  Email: ravenadvisorsllc@gmail.com
                </p>
                <p className="text-gray-700 mt-2" data-id="element-504">
                  Hours: Monday - Friday, 9:00 AM - 6:00 PM CST
                </p>
              </div>
            </div>

            <div data-id="element-505">
              <h2 className="text-2xl font-black text-black uppercase tracking-tight mb-4" data-id="element-506">
                7. No Obligation
              </h2>
              <div className="w-12 h-1 bg-slate-600 mb-6" data-id="element-507"></div>
              <p className="text-gray-700 leading-relaxed" data-id="element-508">
                Requesting a cash offer from Raven Advisors LLC does not
                obligate you to sell your property to us. All offers are
                provided free of charge with no obligation. You are free to
                accept or decline any offer we make.
              </p>
            </div>

            <div data-id="element-509">
              <h2 className="text-2xl font-black text-black uppercase tracking-tight mb-4" data-id="element-510">
                8. Accuracy of Information
              </h2>
              <div className="w-12 h-1 bg-slate-600 mb-6" data-id="element-511"></div>
              <p className="text-gray-700 leading-relaxed" data-id="element-512">
                You agree to provide accurate and complete information about
                yourself and your property when using our services. Providing
                false or misleading information may result in the withdrawal of
                any offer made.
              </p>
            </div>

            <div data-id="element-513">
              <h2 className="text-2xl font-black text-black uppercase tracking-tight mb-4" data-id="element-514">
                9. Offer Terms
              </h2>
              <div className="w-12 h-1 bg-slate-600 mb-6" data-id="element-515"></div>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-516">
                All cash offers made by Raven Advisors LLC are:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2" data-id="element-517">
                <li data-id="element-518">Subject to property inspection and verification</li>
                <li data-id="element-519">Valid for the time period specified in the offer</li>
                <li data-id="element-520">Subject to clear title and standard closing conditions</li>
                <li data-id="element-521">Made in good faith based on current market conditions</li>
              </ul>
            </div>

            <div data-id="element-522">
              <h2 className="text-2xl font-black text-black uppercase tracking-tight mb-4" data-id="element-523">
                10. Closing Process
              </h2>
              <div className="w-12 h-1 bg-slate-600 mb-6" data-id="element-524"></div>
              <p className="text-gray-700 leading-relaxed" data-id="element-525">
                Upon acceptance of an offer, Raven Advisors LLC will work with a
                licensed title company to facilitate the closing. We pay all
                standard closing costs. The closing timeline will be mutually
                agreed upon and can be as fast as 14 days or scheduled according
                to your needs.
              </p>
            </div>

            <div data-id="element-526">
              <h2 className="text-2xl font-black text-black uppercase tracking-tight mb-4" data-id="element-527">
                11. Limitation of Liability
              </h2>
              <div className="w-12 h-1 bg-slate-600 mb-6" data-id="element-528"></div>
              <p className="text-gray-700 leading-relaxed" data-id="element-529">
                Raven Advisors LLC shall not be liable for any indirect,
                incidental, special, consequential, or punitive damages arising
                from your use of our services. Our total liability shall not
                exceed the amount of any fees paid to us for the specific
                transaction in question.
              </p>
            </div>

            <div data-id="element-530">
              <h2 className="text-2xl font-black text-black uppercase tracking-tight mb-4" data-id="element-531">
                12. Intellectual Property
              </h2>
              <div className="w-12 h-1 bg-slate-600 mb-6" data-id="element-532"></div>
              <p className="text-gray-700 leading-relaxed" data-id="element-533">
                All content on this website, including text, graphics, logos,
                and images, is the property of Raven Advisors LLC and is
                protected by copyright and trademark laws. You may not
                reproduce, distribute, or create derivative works without our
                written permission.
              </p>
            </div>

            <div data-id="element-534">
              <h2 className="text-2xl font-black text-black uppercase tracking-tight mb-4" data-id="element-535">
                13. Governing Law
              </h2>
              <div className="w-12 h-1 bg-slate-600 mb-6" data-id="element-536"></div>
              <p className="text-gray-700 leading-relaxed" data-id="element-537">
                These Terms of Service shall be governed by and construed in
                accordance with the laws of the State of Illinois, without
                regard to its conflict of law provisions.
              </p>
            </div>

            <div data-id="element-538">
              <h2 className="text-2xl font-black text-black uppercase tracking-tight mb-4" data-id="element-539">
                14. Changes to Terms
              </h2>
              <div className="w-12 h-1 bg-slate-600 mb-6" data-id="element-540"></div>
              <p className="text-gray-700 leading-relaxed" data-id="element-541">
                We reserve the right to modify these Terms of Service at any
                time. Changes will be effective immediately upon posting to our
                website. Your continued use of our services after any changes
                constitutes acceptance of the new terms.
              </p>
            </div>

            <div data-id="element-542">
              <h2 className="text-2xl font-black text-black uppercase tracking-tight mb-4" data-id="element-543">
                15. Privacy Policy
              </h2>
              <div className="w-12 h-1 bg-slate-600 mb-6" data-id="element-544"></div>
              <p className="text-gray-700 leading-relaxed" data-id="element-545">
                Your use of our services is also governed by our Privacy Policy,
                which describes how we collect, use, and protect your personal
                information. Please review our{' '}
                <Link to="/privacy" className="text-slate-600 underline hover:text-black" data-id="element-546">
                  Privacy Policy
                </Link>{' '}
                for more information.
              </p>
            </div>

            <div data-id="element-547">
              <h2 className="text-2xl font-black text-black uppercase tracking-tight mb-4" data-id="element-548">
                16. Contact Us
              </h2>
              <div className="w-12 h-1 bg-slate-600 mb-6" data-id="element-549"></div>
              <p className="text-gray-700 leading-relaxed" data-id="element-550">
                If you have any questions about these Terms of Service, please
                contact us at:
              </p>
              <div className="mt-4 p-6 bg-gray-50 border-l-4 border-slate-600" data-id="element-551">
                <p className="font-bold text-black" data-id="element-552">Raven Advisors LLC</p>
                <p className="text-gray-700" data-id="element-553">
                  Email: ravenadvisorsllc@gmail.com
                </p>
                <p className="text-gray-700" data-id="element-554">Phone: 630-686-7233</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer data-id="element-555" />
    </div>;
}